export default __webpack_public_path__ + "assets/img_resurs-2d318001.png";